import router from '@/router/index';
export default {
	state: {
		appsEmployeeLoginStatus: false,
		appsEmployeeLoginStatusCode: null,
		appsEmployeeDamageCase: null,
	},
	getters: {
		getAppsEmployeeDamageCase(state) {
			return state.appsEmployeeDamageCase;
		},
		getAppsEmployeeLoginStatus(state) {
			return state.appsEmployeeLoginStatus;
		},
		getAppsEmployeeLoginStatusCode(state) {
			return state.appsEmployeeLoginStatusCode;
		},
	},
	mutations: {
		setAppsEmployeeDamageCase(state, payload) {
			state.appsEmployeeDamageCase = payload;
		},
		setAppsEmployeeLoginStatus(state, payload) {
			state.appsEmployeeLoginStatus = payload;
		},
		setAppsEmployeeLoginStatusCode(state, payload) {
			state.appsEmployeeLoginStatusCode = payload;
		},
		updateAppsEmployeeDamageCaseRepairProof(state, payload) {
			state.appsEmployeeDamageCase.repairProof = payload;
		},
		addTask(state, payload) {
			const task = state.appsEmployeeDamageCase.repair_shop.repairPlanTasks.find(task => task.id === 0);

			if (task) {
				task.name = payload;
			} else {
				state.appsEmployeeDamageCase.repair_shop.repairPlanTasks.push({
					id: 0,
					name: payload,
				});
			}
		},
		logoutEmployee(state) {
			state.appsEmployeeDamageCase = null;
			state.appsEmployeeLoginStatus = false;
			state.appsEmployeeLoginStatusCode = null;
			router.push({ name: 'AppsEmployeeStart' });
		},
	},
	actions: {
		//
	},
};
